<script>
    import { clickOutside } from "$/utils/clickOutside";

    export let showModal = false;
    export let confirm = () => {};

    const handleConfirm = () => {
        confirm();
        showModal = false;
    };
</script>

{#if showModal}
    <div class="leave-cluster-modal-wrapper">
        <div
            class="leave-cluster-modal"
            use:clickOutside
            on:click_outside={() => (showModal = false)}
        >
            <h1>Are you sure you want to leave this cluster?</h1>
            <p>
                This action cannot be undone. You will have to request access
                from the cluster owner to rejoin.
            </p>
            <div class="modal__actions">
                <button
                    class="btn btn--secondary"
                    on:click={() => {
                        showModal = false;
                    }}
                >
                    Cancel
                </button>
                <button class="btn btn--danger" on:click={handleConfirm}>
                    Leave
                </button>
            </div>
        </div>
    </div>
{/if}

<style>
    .leave-cluster-modal-wrapper {
        @apply fixed bottom-0 left-0 right-0 top-0 z-50 flex h-full w-full flex-col items-center justify-center bg-black bg-opacity-30;
    }
    .leave-cluster-modal {
        @apply mx-2 -mt-10 flex flex-col items-center justify-center rounded-xl bg-white px-4 pb-2 pt-4 shadow-2xl;
    }
    .leave-cluster-modal h1 {
        @apply mb-2 text-center text-2xl font-bold;
    }
    .leave-cluster-modal p {
        @apply px-2 text-center text-gray-600;
    }
    .modal__actions {
        @apply mt-2 flex w-full flex-row items-center justify-end gap-2 py-2;
    }
    .modal__actions .btn {
        @apply cursor-pointer rounded-sm px-2 py-1 hover:bg-gray-200;
    }
    .modal__actions .btn--danger {
        @apply font-bold text-pink-500 hover:bg-pink-200;
    }
</style>
